import bootbox from 'bootbox';

import './ConfirmDialog.scss';

/**
 * Show ok dialog with unified style and default configuration
 * @param  {object} config Configuration of confirm dialog:
 *               * title {string, optional} [default none] Title of the dialog, should be similar to name of invoked button text
 *               * message {string, required} Main text of the dialog, could contain html elements (like <br />, <strong>, ect.)
 *               * confirm {string, required} Text of the confirm button. Has to be clear action text (like Disconnect application). NOT: Yes, Do it, etc. + Has to be different from cancel button. Like if some action should be confirm cancable, ask for Interuption. Not should it be cancel? cancel | cancel
 *               * confirmStyle {string, optional} [default btn-primary] class of confirm button. Should reflect type of action (e.g. btn-danger for destuctive actions)
 * @return {Promise}        Resovle on confirm, reject on cancel
 */
export default function okDialog(intl, config) {
    return new Promise((resolve, reject) => {
        bootbox.alert({
            className: 'ConfirmDialog confirm-style-' + (config.confirmStyle || "btn-primary"),
            title: config.title,
            message: config.message,
            callback: (result) => {
                if (result) {
                    resolve();
                }
                else {
                    reject();
                }
            }
        });
    });
}
